import Model from 'core/model/Model';

class TypeGroupModel extends Model {
  get urlRoot() {
    return '/api/ui/labels/userPermLabelGroups';
  }
}

export default TypeGroupModel;
